import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './studio.css';
import './workshop.css';
import './flow-layout.css';

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
